import { render, staticRenderFns } from "./RubyDialog.vue?vue&type=template&id=688f0bdd&scoped=true"
import script from "./RubyDialog.vue?vue&type=script&lang=ts"
export * from "./RubyDialog.vue?vue&type=script&lang=ts"
import style0 from "./RubyDialog.vue?vue&type=style&index=0&id=688f0bdd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688f0bdd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('688f0bdd')) {
      api.createRecord('688f0bdd', component.options)
    } else {
      api.reload('688f0bdd', component.options)
    }
    module.hot.accept("./RubyDialog.vue?vue&type=template&id=688f0bdd&scoped=true", function () {
      api.rerender('688f0bdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/RubyDialog.vue"
export default component.exports